var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('HelloWorld',{attrs:{"msg":"Alan Leonard"}}),_c('h4',[_vm._v("UI Engineer | Front End Developer")]),_c('a',{attrs:{"href":"mailto:alan@alanleonard.net"}},[_vm._v("Contact me")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }